import { render, staticRenderFns } from "./accident-description.vue?vue&type=template&id=75777468"
import script from "./accident-description.vue?vue&type=script&lang=js"
export * from "./accident-description.vue?vue&type=script&lang=js"
import style0 from "./accident-description.vue?vue&type=style&index=0&id=75777468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports